import { OmsFlagKey } from "@redotech/feature-flags-keys-oms/keys";
import type { GetTeam, Settings } from "@redotech/redo-team-common/team";

/** Whether the team sees projected stock: its flag and IMS are both on. */
export function showsInventoryProjection(
  team: { settings: Pick<Settings, "ims"> } & Pick<GetTeam, "featureFlags">,
): boolean {
  return (
    team.featureFlags?.[OmsFlagKey.IMS_INVENTORY_PROJECTION] === true &&
    team.settings.ims?.enabled === true
  );
}
